module.exports = __webpack_public_path__ + "img/content.c09bc3cf.png";